import React, { Fragment, useState } from 'react';
import int1 from './images/anddev.png';
import int2 from './images/webdev.png';
import int3 from './images/engineercore.png';
import int4 from './images/es.png';
import int5 from './images/ybi.png';
import '../styles/internship.css';
import { MDBIcon } from 'mdb-react-ui-kit';

const internshipsData = [
  {
    id: 1,
    image: int1,
    title: 'Android development from Bodhasoft',
    description: 'Working on ongoing projects that center on android app development using React native and Spring MVC',
  },
  {
    id: 2,
    image: int2,
    title: 'Responsive web design from Engineerscore',
    description: 'My internship in Responsive Web Design at Engineerscore involved creating dynamic and responsive web interfaces using HTML, CSS, JavaScript, and Bootstrap.',
  },
  {
    id: 3,
    image: int3,
    title: 'Web development from letgrow more',
    description: 'In the Web Development internship at Letgrow More, I focused on full-stack web development, utilizing HTML, CSS, JavaScript, Node.js, MySQL, and Firebase.',
  },
  {
    id: 4,
    image: int5,
    title: 'Python with DSA from YBI foundation',
    description: 'Through my Python with Data Structures and Algorithms (DSA) internship at YBI Foundation, I strengthened my problem-solving skills and optimized algorithms for various data structures.',
  },
  {
    id: 5,
    image: int4,
    title: 'ES and IOT internship from Vishista Innovators',
    description: 'My Embedded Systems and IoT internship at Vishista Innovators involved developing IoT solutions and building embedded systems with microcontrollers and sensors.',
  },
];

const Internships = () => {
  const [showModal, setShowModal] = useState(false);
  const [displayedInternships, setDisplayedInternships] = useState(internshipsData.slice(0, 2));

  const showMoreInternships = () => {
    setDisplayedInternships(internshipsData);
    setShowModal(true);
  };

  const showLessInternships = () => {
    setDisplayedInternships(internshipsData.slice(0, 3));
    setShowModal(false);
  };

  return (
    <Fragment>
      <center>
        <div className='p-container'>
          {displayedInternships.map((internship) => (
            <div key={internship.id} className='i-box'>
              <img src={internship.image} className='i-img' alt={internship.title} />
              <h3 className='i-h3'>{internship.title}</h3>
              <p className='i-p'>{internship.description}</p>
            </div>
          ))}
        </div>
       
        {internshipsData.length > 3 && (
          
            <div className='i-bo'>
              {showModal ? (
                <p className='showmore'  onClick={showLessInternships}>  <MDBIcon fas icon="angle-double-up" /> Show Less</p>
              ) : (
                <p className='showmore'  onClick={showMoreInternships}>  <MDBIcon fas icon="angle-double-right"/> Show More</p>
              )}
            </div>
           
          )}
      </center>

      {showModal && (
        <div className='modal'>
          <div className='modal-content'>
            <span className='close' onClick={() => setShowModal(false)}>&times;</span>
            {internshipsData.map((internship) => (
              <div key={internship.id} className='i-box'>
                <img src={internship.image} className='i-img' alt={internship.title} />
                <h3 className='i-h3'>{internship.title}</h3>
                <p className='i-p'>{internship.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Internships;
